import { apm } from '@elastic/apm-rum';

const setupApm = (apmBaseUrl: string, version: string, environment: string) => {
  apm.init({
    serviceName: 'invoice_payment_portal',
    serverUrl: apmBaseUrl,
    serviceVersion: version,
    environment: environment,
  });

  apm.addFilter((payload: Payload) => {
    try {
      if (payload.transactions) {
        payload.transactions = payload.transactions.filter((transaction: { name?: String }) =>
          isAppInsights(transaction) ? false : true
        );
      }
      if (payload.errors.length > 0 || payload.transactions.length > 0) {
        return payload;
      }

      return false;
    } catch {
      return payload;
    }
  });
};

const isAppInsights = (transaction: { name?: String | undefined }) => {
  return transaction.name && transaction.name.includes('dc.services.visualstudio.com');
};

export default setupApm;
